import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	InputAdornment,
	IconButton,
	FormControl,
	InputLabel,
	Input,
	FormControlLabel
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Util from "../../validation/index";
import SOLogout from "../../components/Logout/SOLogout";
import { dealerGetPendingRequestList } from "../../redux/actions/dealerPendingRequestListAction";
import { dealerSendInCashInList } from "../../redux/actions/dealerSendInCashInAction"
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 650
	},
	margin: {
		margin: theme.spacing(1)
	},
	root: {
		display: "flex",
		flexWrap: "wrap"
	},
	textField: {
		width: "25ch"
	}
}));
function DealerPendingRequest() {
	const [getCustomerName, setGetCustomerName] = useState("");
	const [getMobNumber, setGetMobNumber] = useState("");

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);

	const [getPendingRequestListStatus, setGetPendingRequestListStatus] =
		useState(false);
	const [getPendingRequestListArray, setGetPendingRequestListArray] = useState(
		[]
	);

	const [getSendInCashInStatus, setGetSendInCashInStatus] =
		useState(false);
	const [getSendInCashInArray, setGetSendInCashInArray] = useState(
		[]
	);



	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const getPendingRequestList = useSelector(
		({ dealerPendingRequestLists }) => dealerPendingRequestLists
	);

	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	// const getPendingRequestList = useSelector(
	//     ({ dealerPendingRequestLists }) => dealerPendingRequestLists
	// )
	const getSendInCashInRes = useSelector(
		({ dealerSendInCashInLists }) => dealerSendInCashInLists
	)
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	// const [sendInCashIn, setSendInCashIn] = useState({

	// 	toCustId: "",
	// 	amount: "",
	// 	narration: "",
	// 	fromCustId: "",
	// 	requestId: "",
	// 	currency: "",
	// 	adminId: "",
	// 	dsrId: "",
	// 	mobileNumber: "",
	// 	fromMobile: "",
	// 	telnocc: "",
	// 	type: "",
	// 	cusOption: "",
	// 	isMoneyFromRequest: "",
	// 	storeId: "",
	// 	verificationHash: ""
	// })

	// const {

	// 	toCustId,
	// 	amount,
	// 	narration,
	// 	fromCustId,
	// 	requestId,
	// 	currency,
	// 	adminId,
	// 	dsrId,
	// 	mobileNumber,
	// 	fromMobile,
	// 	telnocc,
	// 	type,
	// 	cusOption,
	// 	isMoneyFromRequest,
	// 	storeId,
	// 	verificationHash
	// } = sendInCashIn



	const SendCashIn = (actions, custId, amounts, Currency, DsrId, ToMob, FromMob, Narration, ReqId, ToCustId) => {
		setGetSendInCashInStatus(true)
		let req = {
			actionCustomerMasterRequestVO: {
				action: actions,
				dealerId: regenerateTokenRes.data.partnerId,
				toCustId: ToCustId,
				amount: amounts,
				narration: Narration,
				fromCustId: custId,
				requestId: ReqId,
				currency: Currency,
				adminId: "",
				dsrId: DsrId,
				mobileNumber: FromMob,
				fromMobile: ToMob,
				telnocc: "",
				type: "",
				cusOption: "",
				isMoneyFromRequest: "",
				storeId: "",
				verificationHash: ""
			}
		}
		// setSendInCashIn()
		dispatch(dealerSendInCashInList(req, authToken))
	}

	const SendInCashInFunc = () => {
		if (getSendInCashInStatus) {
			if (getSendInCashInRes.data.status == "success") {
				setGetSendInCashInArray(getSendInCashInRes.data)
			}
			if (getSendInCashInRes.data.status == "failed") {
				setGetSendInCashInArray(getSendInCashInRes.data)
			}
		}
	}
	useEffect(() => {
		SendInCashInFunc();

	}, [getSendInCashInRes.data.staus])



	const handleChange = ({ target: { name, value } }) => {
		if (name === "EditMobNumber") {
			Util.verifyMobile(value)
				? setGetMobNumber(value)
				: setGetMobNumber(getMobNumber);
		}
		if (name === "CustomerName") {
			Util.verifyAlphabet(value)
				? setGetCustomerName(value)
				: setGetCustomerName(getCustomerName);
		}
	};

	const getPendingRequestListReq = () => {
		setIsLoading(true);
		setGetPendingRequestListStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				fromCustName: getCustomerName,
				mobileNumber: getMobNumber,
				type: ""
			}
		};
		dispatch(dealerGetPendingRequestList(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getPendingRequestListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getPendingRequestListResFunc = () => {
		if (getPendingRequestListStatus) {
			if (getPendingRequestList.data.status == "success") {
				setIsLoading(false);
				setGetPendingRequestListArray(
					[].concat(getPendingRequestList.data.dsrList)
				);
			}
			if (getPendingRequestList.data.status == "failed") {
				setIsLoading(false);
				setGetPendingRequestListArray(getPendingRequestList.data);
				if (
					getPendingRequestList.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getPendingRequestList.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (getPendingRequestList.data.status == "Not Found") {
				setIsLoading(false);
				setGetPendingRequestListArray(getPendingRequestList.data);
			}
		}
	};

	useEffect(() => {
		getPendingRequestListResFunc();
	}, [getPendingRequestList.data.status]);

	useEffect(() => {
		if (getPendingRequestList.data.status == "success") {
			setPage(0);
		}
	}, [getPendingRequestList.data.status]);



	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="From Customer Name"
								fullWidth={true}
								name="CustomerName"
								value={getCustomerName}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="From Mob Number"
								fullWidth={true}
								name="EditMobNumber"
								value={getMobNumber}
								onChange={handleChange}
							// onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={4}>
							<CustomButton
								style={{
									padding: "8px",
									margin: "8px 8px"
								}}
								variant="contained"
								onClick={getPendingRequestListReq}
							>
								Search
								<SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getPendingRequestListArray.length == undefined ||
					!getPendingRequestListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 themeBackground"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow
												style={{ background: "#00b9f5" }}
												className="themeBackground"
											>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													Request Id{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													From Customer Id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													{" "}
													From Customer Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													From Mob No{" "}
												</TableCell>

												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Currency
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													PayOrder Unique Id{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Narration
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>

											</TableRow>
										</TableHead>
										<TableBody>
											{getPendingRequestListArray &&
												[]
													.concat(getPendingRequestListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.requestId}
															</TableCell>
															<TableCell align="center">
																{row.fromCustId}
															</TableCell>
															<TableCell align="center">
																{row.fromCustomerName}
															</TableCell>
															<TableCell align="center">
																{row.fromMobNumber}
															</TableCell>
															<TableCell align="center">
																{row.amount}
															</TableCell>
															<TableCell align="center">
																{row.currency}
															</TableCell>
															<TableCell align="center">{row.payOrderUniqueId}</TableCell>
															<TableCell align="center">
																{row.narration}
															</TableCell>
															{/* <TableCell align="center">
																{row.verifyStatus}
															</TableCell> */}

															{/* <TableCell align="center">
																<Tooltip title="Send In">
																	<CustomButton
																		style={{
																			padding: "10px"
																		}}
																	// onClick={SendInCashInReq}


																	>
																		{row.type}
																	</CustomButton>
																</Tooltip>
															</TableCell> */}
															<TableCell align="center">
																<Tooltip title="cash in">
																	{row.type == "CASHIN" ? (
																		<CustomButton
																			style={{
																				padding: "10px"
																			}}
																			onClick={() =>
																				SendCashIn(


																					"cashin",
																					row.toCustId,
																					row.amount,
																					row.currency,
																					row.dsrId,
																					row.fromMobNumber,
																					row.tomobile,
																					row.narration,
																					row.requestId,
																					row.fromCustId

																				)
																			}


																		>
																			Cash in


																		</CustomButton>

																	) : (
																		<Tooltip title="send in">
																			<CustomButton
																				style={{
																					padding: "10px"
																				}}
																				// onClick={() => setBlockDsrData(row.customerId)}
																				onClick={() =>
																					SendCashIn(
																						"send",


																					)
																				}


																			>
																				send in

																			</CustomButton>
																		</Tooltip>
																	)
																	}
																</Tooltip>
															</TableCell>


														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getPendingRequestListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
		</>
	);
}

export default DealerPendingRequest;
